import React, { createContext, useState } from "react";

//CONSTANT
import { USER_DEAFULT_KEY } from "../constant/event";

//API
import { SET_CERTIFICATE_NAME } from "../api/firebase_user";

export const BundleContext = createContext();

export const BundleProvider = (props) => {
  // Initialize directly from localStorage (synchronous) to avoid
  // a render cycle where children see "" before the actual value
  const [selectedCertificate, setSelectedCertificate] = useState(
    () => localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS) || ""
  );

  async function setSelectedBundle(key) {
    localStorage.setItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS, key);
    
    await SET_CERTIFICATE_NAME(key); // Set the certificate name in user collection in the database
    setSelectedCertificate(key);
    return;
  }

  return (
    <BundleContext.Provider
      value={{
        selectedCertificate,
        setSelectedBundle,
      }}
    >
      {props.children}
    </BundleContext.Provider>
  );
};
